// extracted by mini-css-extract-plugin
export default {"SkillsCard":"SkillsCard_SkillsCard__A0BOD"};